import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
} from '@material-ui/core';
import { CheckCircleOutlineSharp } from '@material-ui/icons';


const RedirectRewardContentDialog = ({open, setOpen, setOpenRewardInfoEditor}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="info-dialog"
      PaperProps={{
        className: 'border-radius-6'
      }}
      maxWidth={'sm'}
    >
      <DialogTitle id="confirm-dialog" className="flex-column w-full p-3">
        <div className="flex justify-end">
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="flex-column items-center">
        <CheckCircleOutlineSharp
          style={{ color: '#4caf50', fontSize: '80px' }}
          className="mb-5"
        />
        <span className="mb-5">
          Your rule has been saved successfully.
        </span>
        <span>
          Please make sure it matches your Reward Program Content.
        </span>
      </DialogContent>
      <div className="py-5 px-20 text-center">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setOpenRewardInfoEditor(true);
            setOpen(false);
          }}
        >
          <Icon className="mr-2">edit</Icon>
          Edit Rewards Program Content
        </Button>
      </div>
    </Dialog>
  );
};

export default RedirectRewardContentDialog;
